/**
 * Resource and location utilities
 */

import {
    GetApiProjectResourceApiResponse,
    ProjectResourceAssignmentModel,
    ProjectResourceModel,
} from 'store/userOrg/userOrgApi';
import { GetApiLocationApiResponse, LocationModel } from 'store/userOrg/userOrgAdministrationApi';

/**
 * Finds resource and location by zone name
 */
export const findResourceAndLocationByZoneName = (
    resources: GetApiProjectResourceApiResponse | undefined,
    zoneName: string | undefined
) => {
    const resource = resources?.find(resource =>
        resource?.Assignments?.some(
            assignment =>
                assignment?.Specifications?.some(spec => spec.Key === 'ZONE_NAME' && spec.Value === zoneName) &&
                assignment?.Specifications?.some(spec => spec?.Key === 'DDI_TARGET')
        )
    );

    const assignment = resource?.Assignments?.find(
        assignment =>
            assignment.Specifications?.some(spec => spec.Key === 'ZONE_NAME' && spec.Value === zoneName) &&
            assignment?.Specifications?.some(spec => spec?.Key === 'DDI_TARGET')
    );

    return { resourceName: resource?.Name, locationName: assignment?.LocationName };
};

/**
 * Filters locations by assignments
 */
export const filterLocationsByAssignments = (
    resourcesData: GetApiProjectResourceApiResponse | undefined,
    locationsList: GetApiLocationApiResponse | undefined
) => {
    const filteredResults: {
        location: LocationModel;
        assignment: ProjectResourceAssignmentModel;
        resource: ProjectResourceModel;
    }[] = [];

    resourcesData?.forEach(resource => {
        resource?.Assignments?.forEach(assignment => {
            const matchingLocation = locationsList?.find(
                location => location.Id === assignment.LocationId && location.LocationTypeId === 5
            );

            if (matchingLocation) {
                filteredResults.push({ location: matchingLocation, assignment, resource });
            }
        });
    });

    return filteredResults;
};

export const filterLocationsDSpaceByAssignments = (
    resourcesData: GetApiProjectResourceApiResponse | undefined,
    locationsList: GetApiLocationApiResponse | undefined
) => {
    const filteredResults: {
        location: LocationModel;
        assignment: ProjectResourceAssignmentModel;
        resource: ProjectResourceModel;
    }[] = [];

    resourcesData?.forEach(resource => {
        resource?.Assignments?.forEach(assignment => {
            const matchingLocation = locationsList?.find(
                location => location.Id === assignment.LocationId && location.LocationTypeId === 6
            );

            if (matchingLocation) {
                filteredResults.push({ location: matchingLocation, assignment, resource });
            }
        });
    });

    return filteredResults;
};
